import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/AboutImpact.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExpertiseCard"] */ "/vercel/path0/components/ExpertiseCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Hero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Newsletter.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Projects.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/TechStack.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Testimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
